export const SET_AVAILABLE_DATES = 'SET_AVAILABLE_DATES'
export const SET_START_DATE = 'SET_START_DATE'
export const SET_END_DATE = 'SET_END_DATE'

export default {
  [SET_AVAILABLE_DATES] (state, value) {
    state.availableDates = value
  },
  [SET_START_DATE] (state, value) {
    state.startDate = value
  },
  [SET_END_DATE] (state, value) {
    state.endDate = value
  }
}



// WEBPACK FOOTER //
// ./src/app/appComponents/workbench/lasGraphs/viewership/dateRange/store/mutations.js